import React from 'react'; 
import StorefrontIcon from '@mui/icons-material/Storefront';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const StoreCard = ({ store }) => {
  const navigate = useNavigate();
  const { name, location } = store;

  return (
    <div
      className='border p-4 rounded-xl bg-white shadow-md flex flex-col items-center space-y-3 cursor-pointer hover:scale-105 transition-transform duration-300'
      onClick={() => navigate(`/dashboard/stores/inventory/${name}`)}
    >
      {/* Icon */}
      <div className='h-20 w-20 flex items-center justify-center rounded-full bg-maroon-500 text-white'>
        <StorefrontIcon sx={{ fontSize: 40 }} />
      </div>

      {/* Store Name */}
      <h2 className='text-lg font-semibold text-center truncate'>{name}</h2>

      {/* Location */}
      <div className='flex items-center space-x-1 text-gray-600 text-sm'>
        <MyLocationIcon sx={{ fontSize: 16 }} />
        <p className='truncate'>{location}</p>
      </div>

      {/* View Button */}
      <Button
        size='small'
        variant='outlined'
        onClick={(e) => {
          e.stopPropagation(); // prevent card click
          navigate(`/dashboard/stores/inventory/${name}`);
        }}
      >
        View
      </Button>
    </div>
  );
};

export default StoreCard;
